import { useCallback, useMemo, useState } from 'react';

import type { InvoiceEmailPageCallbacks } from '../invoice-email-page-callbacks';
import type { InvoiceQuerySchema } from '../schemas/invoices/invoice-query-schema';

type UseInvoiceEmailControllerOptions = {
  onAfterSendEnd?: () => void;
};

export function useInvoiceEmailController({ onAfterSendEnd }: UseInvoiceEmailControllerOptions = {}) {
  const [emailModalInvoice, setEmailModalInvoice] = useState<InvoiceQuerySchema | null>(null);
  const [sendingInvoiceId, setSendingInvoiceId] = useState<number | null>(null);

  const openEmailModal = useCallback((invoice: InvoiceQuerySchema) => {
    setEmailModalInvoice(invoice);
  }, []);

  const closeEmailModal = useCallback(() => {
    setEmailModalInvoice(null);
  }, []);

  const beginSendingInvoice = useCallback((invoiceId: number) => {
    setSendingInvoiceId(invoiceId);
  }, []);

  const endSendingInvoice = useCallback(() => {
    setSendingInvoiceId(null);
    onAfterSendEnd?.();
  }, [onAfterSendEnd]);

  const emailCallbacks = useMemo<InvoiceEmailPageCallbacks>(
    () => ({
      openEmailModal,
      beginSendingInvoice,
      endSendingInvoice,
    }),
    [openEmailModal, beginSendingInvoice, endSendingInvoice]
  );

  return {
    emailModalInvoice,
    sendingInvoiceId,
    openEmailModal,
    closeEmailModal,
    beginSendingInvoice,
    endSendingInvoice,
    emailCallbacks,
  };
}
